<template>
  <slot :products="products" />
</template>

<script>
import featuredCollectionQuery from "@/graphql/queries/FeaturedCollection.gql";
import { unwrapNodes } from "@/helpers/graphql";
import { PER_PAGE } from "@/helpers/pagination";

export default {
  name: "CollectionCarouselHelper",
  props: {
    collectionHandle: {
      type: String,
      required: true,
    },
    first: {
      type: Number,
      default: PER_PAGE,
    },
  },
  data() {
    return {
      products: [],
    };
  },
  apollo: {
    products: {
      query: featuredCollectionQuery,
      skip() {
        return !this.collectionHandle;
      },
      variables() {
        return {
          collection: this.collectionHandle,
          first: this.first,
        };
      },
      update({ collection }) {
        return unwrapNodes(collection.products?.edges);
      },
    },
  },
};
</script>
